import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iSupplier } from "./supplier-model";

export class SuppliersServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.suppliers.configure(config);
  }

  suppliers = new EntityServices<iSupplier>(SDKConfig, "suppliers", {});
}
